import { PublicClientApplication } from '@azure/msal-browser/dist/app/PublicClientApplication';
import configuration from './configuration';
import { MsalConfiguration } from './configuration/Interfaces';

export default configuration.IsStandalone
  ? new PublicClientApplication((configuration as MsalConfiguration).Msal)
  : ({} as any as PublicClientApplication);
